import { AxiosError } from 'axios';

import { Interceptor } from 'app/api/interceptor/Interceptor';

export function createErrorInterceptors(interceptors: Interceptor[]) {
    return (error: AxiosError) => {
        interceptors.forEach((interceptor) => {
            interceptor.process(error);
        });
    };
}
